import React from 'react'
import { about_us } from '../../constants'
import './About.css'
import about_bg from '../../assets/about_bg.png'
export default function About() {
    return (
        <div className='about__container' style={{backgroundImage : `url(${about_bg})`}}>
            <div className='about' >
                <h1 className={"heading_section"}> {about_us.title}</h1>
                <p>
                    {about_us.text}
                </p>
            </div>
        </div>

    )
}
